module.exports = __webpack_public_path__ + "static/media/shape_4.dedcbc25.png";